import { render, staticRenderFns } from "./SeleccionFormatoInforme.vue?vue&type=template&id=915f3770&scoped=true&"
import script from "./SeleccionFormatoInforme.vue?vue&type=script&lang=ts&"
export * from "./SeleccionFormatoInforme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915f3770",
  null
  
)

export default component.exports